import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { Location } from '@/models/location';
import { Customer } from '@/models/tenant';
import { UserType } from '@/models/userType';
import { locationsService } from '@/services/locations.service';
import { isNil } from '@/utils/misc';
import { hasCurrentUserPermission } from '@/utils/permissionUtils';
import { required, withLocalizedValidators } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { computed, onMounted, reactive, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationFormModal',
  props: {
    location: null,
    customer: null
  },
  emits: ['save', 'close'],
  setup(__props: any, { emit }) {

const props = __props as {
  location?: Location;
  customer: Customer;
};





const editedLocation = reactive(
  Location.GetCopy(props.location ?? Location.GetEmpty()),
);
const isSubmitting = ref(false);

const { t } = useI18n();

const validations = {
  name: withLocalizedValidators('form.name', {
    required,
  }),
  address: withLocalizedValidators('location.address', {
    required,
  }),
  zipCode: withLocalizedValidators('location.zipCode', {
    required,
  }),
  country: withLocalizedValidators('location.country', {
    required,
  }),
};
const v$ = useVuelidate(validations, editedLocation);

onMounted(() => {
  if (!isEdit.value) {
    editedLocation.tenantId = props.customer.id;
  }
});

async function onSubmit() {
  isSubmitting.value = true;
  try {
    if (isEdit.value) {
      await locationsService.update(editedLocation);
    } else {
      await locationsService.create(editedLocation);
    }
    emit('save');
    emit('close');
  } finally {
    isSubmitting.value = false;
  }
}

function getErrorMessage(key: keyof typeof editedLocation): string | undefined {
  return v$.value[key].$errors?.[0]?.$message;
}

const canEditLocation = computed((): boolean =>
  hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);

const isEdit = computed(() => !isNil(props.location));

return { __sfc: true,props, emit, editedLocation, isSubmitting, t, validations, v$, onSubmit, getErrorMessage, canEditLocation, isEdit }
}

})